export default __webpack_public_path__ + "static/media/img_logo_ducati.8bd9dd9e.svg";